module.exports = __webpack_public_path__ + "img/add-your-equipment.b903d2cf.gif";